import React from 'react';
import { useParams } from 'react-router-dom';
import { useQuery } from '@apollo/client';
import { Alert, Spin } from 'antd';
import { GET_SITE_VISIT } from '../../graphql/queries/siteVisit';
import { ISiteVisit } from './types';
import Summary from './Summary';
import { commonStyles } from './styles/common';

interface SiteVisitViewProps {
  id?: string;
  onEdit?: () => void;
  onNext?: () => void;
  showShare?: boolean;
}

const SiteVisitView: React.FC<SiteVisitViewProps> = ({
  id: propId,
  onEdit,
  onNext,
  showShare,
}) => {
  const { id: paramId } = useParams<{ id: string }>();
  const siteVisitId = propId || paramId;

  const { data, loading, error } = useQuery(GET_SITE_VISIT, {
    variables: { id: siteVisitId },
    skip: !siteVisitId,
    fetchPolicy: 'network-only',
  });

  if (!siteVisitId) {
    return (
      <Alert
        message="Error"
        description="Site visit ID not provided"
        type="error"
        style={commonStyles.errorAlert}
      />
    );
  }

  if (loading) {
    return (
      <div style={commonStyles.loadingContainer}>
        <Spin size="large" />
      </div>
    );
  }

  if (error) {
    return (
      <Alert
        message="Loading Error"
        description={error.message}
        type="error"
        style={commonStyles.errorAlert}
      />
    );
  }

  if (!data?.siteVisit) {
    return (
      <Alert
        message="Not Found"
        description="Site visit not found"
        type="warning"
        style={commonStyles.errorAlert}
      />
    );
  }

  const siteVisit: ISiteVisit = data.siteVisit;

  return (
    <div style={commonStyles.toolContainer}>
      <Summary siteVisit={siteVisit} onEdit={onEdit} onNext={onNext} showShare={showShare} />
    </div>
  );
};

export default SiteVisitView;
